import React, { useEffect, useState } from 'react';
import SaveButton from '../../components/Buttons/SaveButton';
import ButtonBar from '../../components/Fields/ButtonBar';
import { FormConfig } from '../../components/Fields/Types';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import SpinnerOverlay from '../../components/Spinner/SpinnerOverlay';
import { useNotifications } from '../../contexts/notificationContext';
import SettingsModel from '../../models/settings/SettingsModel';
import DataService from "../../services/data.service";
import { DataResult } from '../../types/Result';
import SettingGroup from './Components/SettingGroup';

const SettingsView: React.FC = () => {
    const [formData, setFormData] = useState<SettingsModel>();
    const [serverErrors, setServerErrors] = useState<DataResult<SettingsModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    useEffect(() => {
        getFormData();
    }, []);

    function getFormData() {
        DataService.get<SettingsModel>('api/v1/Settings/')
            .then(response => {
                console.log('Settings:', response)
                setFormData(response);
            })
            .catch(e => { handleException(e); });
    }

    function submit() {
        if (formData) {
            DataService
                .put<DataResult<SettingsModel>>(`api/v1/Settings`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [],
        handleSubmit: submit,
        showErrors: 'always',
    };

    if (formData) {
        formData.emailSettings.settings.forEach((setting, index) => {
            formConfig.fields.push({ name: `emailSettings.settings.${index}.value`, label: setting.settingName, labelSize: 4 });
            formConfig.fields.push({ name: `emailSettings.settings.${index}.level`, label: 'Level', labelSize: 4 });
        });
        formData.storageSettings.settings.forEach((setting, index) => {
            formConfig.fields.push({ name: `storageSettings.settings.${index}.value`, label: setting.settingName, labelSize: 4 });
            formConfig.fields.push({ name: `storageSettings.settings.${index}.level`, label: 'Level', labelSize: 4 });
        });
        formData.documentTemplateSettings.settings.forEach((setting, index) => {
            formConfig.fields.push({ name: `documentTemplateSettings.settings.${index}.value`, label: setting.settingName, labelSize: 4 });
            formConfig.fields.push({ name: `documentTemplateSettings.settings.${index}.level`, label: 'Level', labelSize: 4 });
        });
    }

    const { getControlProps, getLabelProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    if (!formData)
        return <SpinnerOverlay />

    return (
        <div style={{ flexDirection: "row" }}>
            <SettingGroup fieldName={'emailSettings.settings'} getControlProps={getControlProps} getLabelProps={getLabelProps} settingGroup={formData.emailSettings} />
            <SettingGroup fieldName={'storageSettings.settings'} getControlProps={getControlProps} getLabelProps={getLabelProps} settingGroup={formData.storageSettings} />
            <SettingGroup fieldName={'documentTemplateSettings.settings'} getControlProps={getControlProps} getLabelProps={getLabelProps} settingGroup={formData.documentTemplateSettings} />
            <ButtonBar offset={2}>
                <SaveButton  {...getSubmitButtonProps()} />
            </ButtonBar>
        </div>
    );
}
export default SettingsView;